/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 11:12:26
 * @LastEditors: limin
 * @LastEditTime: 2021-04-20 11:40:16
 */
import {
  CART_ADD_PRODUCT_TO_CART,
  CART_DEL_PRODUCT_TO_CART,
  CART_ADD_PRODUCT_QUANTITY,
  CART_DEL_PRODUCT_QUANTITY,
  CART_SET_CHECKOUT_STATUS,
  CART_SET_CHECKOUT_STATUS_ALL,
  CART_GET_CART_PRODUCT_LIST
} from "../types";
import apis from "@/apis";

const {
  cart: { get, add, remove, edit }
} = apis;

const state = {
  items: []
};

// 定义 getters
const getters = {
  // 返回购物车商品列表完整信息
  cartProducts: ({ items }, getters, rootState) => {
    return items;
    // if (!state.items.length) return [] // map不会对空数组进行检测 map不会改变原始数组
    // return state.items.map(({ id, quantity, checked }) => { // map()方法返回一个新数组，数组中的元素为原始数组元素调用函数处理的后值。
    //   const product = rootState.products.recommendList.find(product => product.id === id) // 拿到items中的数据去查阅products中的数据, rootState(根节点状态)参数可以拿到别的模块的state状态
    //   if (!product) return {} // action请求异步，如果此时的数据还没有请求回来 就返回空对象
    //   return {
    //     src: product.image, // product的图片地址
    //     name: product.name, // product的名字
    //     price: product.price, // product的单价
    //     id, // product的id
    //     quantity, // product的数量，默认为1
    //     simpleTotal: quantity * product.price, // 单项product的总价价
    //     checked // product的选中状态
    //   }
    // })
  },
  // 返回选中商品的总价
  cartTotalPrice: (state, getters) => {
    return getters.cartProducts.reduce((total, {checked,goodsNum,preferentialPrice}) => {
      if (checked) {
        return total + parseFloat(preferentialPrice *goodsNum);
      }
      return total;
    }, 0);
  },
  // 返回所有商品总价,不管有没有选中
  allPrice: (state, getters) => {
    return getters.cartProducts.reduce((total, {goodsNum,preferentialPrice}) => {
      return total + parseFloat(preferentialPrice * goodsNum);
    }, 0);
  },
  // 返回所有商品总数量,不管有没有选中
  allProducts: (state, getters) => {
    return getters.cartProducts.reduce((total, {goodsNum}) => {
      return total + goodsNum;
    }, 0);
  },
  // 返回所有被选中的商品
  allSelectItems: (state, getters) => {
    return getters.cartProducts.filter(p => p.checked);
  },
  // 返回所有选中的商品数量
  allSelectItemsCount: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      if (product.checked) {
        return total + product.goodsNum;
      }
      return total;
    }, 0);
  },
  // 返回所有商品条数
  allProductsItemLength: state => {
    return state.items.length;
  },
  // 返回商品是否全选 是返回true 否则false
  isSelectAll: ({ items }) => {
    if (!items.length) return false;
    return items.every(item => {
      // every() 不会对空数组进行检测
      return item.checked === true;
    });
  },
  // 返回是否有选中的商品 是返回true 否则false
  hasSelect: state => {
    if (!state.items.length) return false;
    return state.items.some(item => {
      // some() 不会对空数组进行检测
      return item.checked === true;
    });
  }
};

const actions = {
  getCartList({ commit }, fn) {
    get({pageNum:1,pageSize:10000}).then(({list}) => {
      commit(CART_GET_CART_PRODUCT_LIST, list);
      fn && fn();
    });
  },
  // 添加购物车的方法,如果此时购物车内有该条商品,就添加商品数量,否则添加商品
  addProductToCart({ state, commit, dispatch }, product) {
    const cartItem = state.items && state.items.find(item => item.goodsId === product.goodsId)||null;
    return new Promise(resolve=>{
      if (!cartItem) {
        add(product).then(res => {
          dispatch("getCartList");
          resolve('加入购物车成功')
        });
        // commit(CART_ADD_PRODUCT_TO_CART, product)
      } else {
        const {goodsNum, purchaseQuantity} = cartItem;
        const total = +goodsNum+ +product.goodsNum;
        if(total <= purchaseQuantity || purchaseQuantity === null
          || purchaseQuantity === '') {
          edit(cartItem.id, total).then(res => {
            dispatch("getCartList");
            resolve('加入购物车成功')
          });
        } else {
          window.vm.$toast(`该商品限购量为${purchaseQuantity}`); //TODO 此处不应该直接提示 参考上面的resolve
        }
        // commit(CART_ADD_PRODUCT_QUANTITY, {id:product.id,quantity:product.quantity})
      }
    })
  },
  // 购物车内删除一条商品的方法
  delProductToCart({ dispatch }, id) {
    remove(id).then(res => {
      dispatch("getCartList");
    });
  },
  // 添加商品数量的方法
  addProductQuantity({ commit }, id) {
    commit(CART_ADD_PRODUCT_QUANTITY, id);
  },
  // 减少商品数量的方法
  delProductQuantity({ commit }, id) {
    commit(CART_DEL_PRODUCT_QUANTITY, id);
  },
  // 切换一条商品的选中状态的方法
  setChecked({ commit }, id) {
    commit(CART_SET_CHECKOUT_STATUS, id);
  },
  // 切换所有商品选中状态的方法
  setCheckedAll({ commit }, status) {
    commit(CART_SET_CHECKOUT_STATUS_ALL, status);
  }
};

const mutations = {
  [CART_GET_CART_PRODUCT_LIST](state, items) {
    state.items = items;
  },
  // 添加一条商品的方法
  [CART_ADD_PRODUCT_TO_CART](state, product) {
    state.items.push({
      ...product,
      checked: false
    });
  },
  // 删除一条商品的方法
  [CART_DEL_PRODUCT_TO_CART](state, id) {
    state.items.forEach((item, index) => {
      if (item.id === id) {
        state.items.splice(index, 1);
      }
    });
  },
  // 增加一条商品中商品数量的方法
  [CART_ADD_PRODUCT_QUANTITY](state, id) {
    const cartItem = state.items.find(item => item.id == id);
    var quantity = cartItem.goodsNum
    quantity++;
    edit(id, quantity).then(_=>{
      cartItem.goodsNum = quantity
      // $vue.$set(cartItem,'goodsNum',quantity)
    })
  },
  // 减少一条商品中商品数量的方法
  [CART_DEL_PRODUCT_QUANTITY](state, id) {
    const cartItem = state.items.find(item => item.id == id);
    var quantity = cartItem.goodsNum
    if (quantity > 1) {
      // 商品数量大于1时才能减少
      quantity--;
    } else quantity = 1;
    edit(id, quantity).then(_=>{
      cartItem.goodsNum = quantity
    })
  },
  // 改变单条商品的选中不选中状态的方法(单选按钮)
  [CART_SET_CHECKOUT_STATUS](state, id) {
    const cartItem = state.items.find(item => item.id == id);
    cartItem.checked = !cartItem.checked;
  },
  // 改变所有商品的选中不选中状态的方法(全选按钮)
  [CART_SET_CHECKOUT_STATUS_ALL](state, {status,$vue}) {
    state.items.forEach((item) => {
      console.log(status);
      $vue.$set(item,'checked',status)
    });
  }
};
// 最后统一导出
export default {
  namespaced: true, // 添加命名空间
  state,
  getters,
  mutations,
  actions
};
